import { lazy } from 'react';
import { ICONS } from '../navigationIcons';

const SettingsPage = lazy(() => import('src/compass/pages/administration/SettingsPage'));
const IntegrationsPage = lazy(() => import('src/compass/pages/administration/IntegrationsPage'));
const DemoEnvironmentsPage = lazy(
  () => import('src/compass/pages/administration/DemoEnvironmentsPage')
);
const UserOwnerMappingPage = lazy(
  () => import('src/compass/pages/administration/UserOwnerMappingPage')
);
const ReleaseNotesPage = lazy(() => import('src/compass/pages/administration/ReleaseNotesPage'));
const SupportPage = lazy(() => import('src/compass/pages/administration/SupportPage'));
const UploadsManagementPage = lazy(() => import('src/compass/pages/administration/UploadsManagementPage'));
const LrpQuotesRedirectorPage = lazy(() => import('src/compass/pages/administration/LrpQuotesRedirectorPage'));
const ConfigurationPage = lazy(() => import('src/compass/pages/administration/ConfigurationPage'));

export const AdministrationMenu = [
  {
    menuTitle: 'Administration',
    path: 'administration',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Settings',
        path: 'settings',
        element: <SettingsPage />,
        permission: 'ADMIN',
      },
      {
        title: 'Support',
        path: 'support',
        element: <SupportPage />,
        permission: 'SUPPORT',
      },
      {
        title: 'Configuration',
        path: 'configuration',
        element: <ConfigurationPage />,
        permission: 'CONFIGURATION',
      },
      {
        title: 'Integrations',
        path: 'integrations',
        element: <IntegrationsPage />,
        // One resource per tab, in tab order - the same list IntegrationsPage filters its tabs by
        permission: ['ADMIN_DOCUSIGN', 'ADMIN_EHARVEST', 'HUBSPOT', 'ADMIN_RINGCENTRAL'],
      },
      {
        title: 'Demo Environments',
        path: 'demoenvironments',
        element: <DemoEnvironmentsPage />,
        permission: 'DEMO_ENVS',
      },
      {
        title: 'User Owner Mapping',
        path: 'userownermapping',
        element: <UserOwnerMappingPage />,
        permission: 'LEGACY',
      },
      {
        title: 'Release Notes',
        path: 'releasenotes',
        element: <ReleaseNotesPage />,
        permission: 'RELEASE_NOTES',
      },
      {
        title: 'Uploads Management',
        path: 'uploadsmanagement',
        element: <UploadsManagementPage />,
        permission: 'UPLD_MGT',
      },
      {
        title: 'Public LRP Quotes',
        path: 'lrp-quotes',
        element: <LrpQuotesRedirectorPage />,
        permission: 'ADMIN',
      },
    ],
  },
];
